import { Dialog, Pane, Heading, Text, Button, TrashIcon, IconButton } from 'evergreen-ui';

export default function TurniDayDetailModal({
  isOpen,
  onClose,
  selectedDay,
  isDirector,
  onRemoveShift,
  onAssignClick
}) {
  if (!selectedDay) return null;

  // Rovescia la data da yyyy-mm-dd a dd/mm/yyyy
  const formattedDate = selectedDay.fullDate && selectedDay.fullDate.includes('-')
    ? selectedDay.fullDate.split('-').reverse().join('/')
    : selectedDay.fullDate;

  const renderShifts = (typeLabel, shiftKey) => {
    let rawShifts = [];
    if (selectedDay.shifts.raw) {
      if (shiftKey === "turno") {
        rawShifts = selectedDay.shifts.raw.filter(t => !['ferie', 'permesso', 'malattia'].includes(t.shift_type));
      } else {
        rawShifts = selectedDay.shifts.raw.filter(t => t.shift_type === shiftKey);
      }
    }

    return (
      <Pane background="tint2" padding={12} borderRadius={4}>
        <Heading size={500} color="muted">{typeLabel}</Heading>
        {rawShifts.length === 0 ? (
          <Text color="danger">Nessun turno pianificato</Text>
        ) : (
          rawShifts.map(rs => (
            <Pane key={rs.id} display="flex" alignItems="center" justifyContent="space-between" marginTop={4}>
              <Pane display="flex" alignItems="center" gap={8} flexWrap="wrap">
                <Text>{rs.operator_name}</Text>
                <Text size={300} color="muted">({rs.start_time?.substring(0,5) || '?'} - {rs.end_time?.substring(0,5) || '?'})</Text>
                {parseInt(rs.is_overtime, 10) === 1 && <Text size={300} color="warning">(Straordinario)</Text>}
                {rs.status === 'timbrato' && <Text size={300} color="success">[Timbrato]</Text>}
              </Pane>
              {isDirector && <IconButton icon={TrashIcon} intent="danger" appearance="minimal" onClick={() => onRemoveShift(rs.id)} />}
            </Pane>
          ))
        )}
      </Pane>
    );
  };

  const renderFerie = () => {
    let rawShifts = [];
    if (selectedDay.shifts.raw) {
      rawShifts = selectedDay.shifts.raw.filter(t => ['ferie', 'permesso', 'malattia'].includes((t.shift_type || '').toLowerCase()));
    }
    if (rawShifts.length === 0) return null;

    return (
      <Pane background="redTint" padding={12} borderRadius={4} marginTop={8}>
        <Heading size={500} color="danger">Assenti (Ferie / Permessi / Malattia)</Heading>
        {rawShifts.map(rs => (
          <Pane key={rs.id} display="flex" alignItems="center" justifyContent="space-between" marginTop={4} paddingBottom={4} borderBottom="muted">
            <Text>{rs.operator_name}</Text>
            <Pane display="flex" alignItems="center" gap={8} flexWrap="wrap">
              {isDirector ? (
                <>
                  <Text size={300} color="muted">[{rs.shift_type.toUpperCase()}]</Text>
                  {['permesso', 'ferie'].includes((rs.shift_type || '').toLowerCase()) && rs.start_time && rs.start_time.substring(0,5) !== '00:00' && rs.end_time && (
                    <Text size={300} color="muted">({rs.start_time.substring(0,5)} - {rs.end_time.substring(0,5)})</Text>
                  )}
                </>
              ) : (
                <Text size={300} color="muted">[ASSENTE]</Text>
              )}
            </Pane>
          </Pane>
        ))}
      </Pane>
    );
  };

  return (
    <Dialog
      isShown={isOpen}
      title={`Dettaglio turni: ${formattedDate}`}
      onCloseComplete={onClose}
      hasFooter={false}
    >
      <Pane display="flex" flexDirection="column" gap={16}>
        {renderFerie()}
        {renderShifts("Turni pianificati", "turno")}
        {isDirector && (
          <Pane display="flex" justifyContent="flex-end" gap={8} marginTop={24} paddingBottom={8}>
            <Button onClick={() => onAssignClick(selectedDay.fullDate)}>Inserisci turno per questo giorno</Button>
          </Pane>
        )}
      </Pane>
    </Dialog>
  );
}